/** Ключи localStorage для смещений мест (только клиент). */
export const SEAT_OFFSET_STORAGE = Object.freeze({
  local: 'seka-local-seat-offsets-v1',
  online: 'seka-online-seat-offsets-v1',
});

export function clampSeatCenter(leftPct, topPct) {
  return {
    leftPct: Math.min(94, Math.max(6, leftPct)),
    topPct: Math.min(94, Math.max(6, topPct)),
  };
}

/** Белот igra, эллипс: чуть шире по краям, сильнее по вертикали — центр стола свободнее. */
export function clampSeatBelotIgraEllipse(leftPct, topPct) {
  return {
    leftPct: Math.min(95, Math.max(5, leftPct)),
    topPct: Math.min(96.5, Math.max(3.5, topPct)),
  };
}

/**
 * @param {{ dLeft?: number, dTop?: number }} [off]
 * @param {{ belotIgraEllipse?: boolean }} [options] — мягче clamp для локального igra-стола.
 */
export function seatDisplayPercents(slot, off, options = {}) {
  const dl = off?.dLeft ?? 0;
  const dt = off?.dTop ?? 0;
  const left = slot.leftPct + dl;
  const top = slot.topPct + dt;
  if (options.belotIgraEllipse) return clampSeatBelotIgraEllipse(left, top);
  return clampSeatCenter(left, top);
}

function readRoot(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return {};
    const o = JSON.parse(raw);
    return o && typeof o === 'object' && !Array.isArray(o) ? o : {};
  } catch {
    return {};
  }
}

export function loadOffsetsForBlock(storageKey, blockKey) {
  const root = readRoot(storageKey);
  const block = root[String(blockKey)];
  if (!block || typeof block !== 'object' || Array.isArray(block)) return {};
  const out = {};
  Object.entries(block).forEach(([k, v]) => {
    const seat = Number(k);
    if (!Number.isFinite(seat) || seat < 0 || seat > 15) return;
    const dLeft = Number(v?.dLeft);
    const dTop = Number(v?.dTop);
    if (!Number.isFinite(dLeft) || !Number.isFinite(dTop)) return;
    out[seat] = { dLeft, dTop };
  });
  return out;
}

export function saveOffsetsForBlock(storageKey, blockKey, offsetsBySeat) {
  try {
    const root = readRoot(storageKey);
    const serial = {};
    Object.entries(offsetsBySeat || {}).forEach(([k, v]) => {
      if (!v || typeof v !== 'object') return;
      const dLeft = Number(v.dLeft);
      const dTop = Number(v.dTop);
      if (!Number.isFinite(dLeft) || !Number.isFinite(dTop)) return;
      serial[String(k)] = { dLeft, dTop };
    });
    root[String(blockKey)] = serial;
    localStorage.setItem(storageKey, JSON.stringify(root));
  } catch {
    /* quota / private mode */
  }
}

export function clearOffsetsForBlock(storageKey, blockKey) {
  try {
    const root = readRoot(storageKey);
    delete root[String(blockKey)];
    localStorage.setItem(storageKey, JSON.stringify(root));
  } catch {
    /* ignore */
  }
}
